import { cx } from '@emotion/css';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Dialog as MUIDialog } from '@mui/material';
import React, { useCallback } from 'react';
import { ix } from '../../../utils/ix';
import { useStyles } from './Dialog.styles';
export function Dialog(props) {
    const classes = useStyles();
    const { onClose } = props;
    const handleClose = useCallback((event, reason) => {
        if (reason === 'backdropClick' && props.disableBackdropClick) {
            return;
        }
        if (onClose) {
            onClose(event);
        }
    }, [onClose, props.disableBackdropClick]);
    return (React.createElement(MUIDialog, { className: cx(props.className, classes.root, {
            disableBackdrop: props.disableBackdrop,
        }), classes: {
            paper: classes.paper,
        }, id: props.id, open: props.open, onClose: handleClose, "data-testid": props.testid, maxWidth: props.maxWidth, fullWidth: props.fullWidth },
        props.onClose && !props.hideCloseIcon && (React.createElement(IconButton, { "aria-label": "close", className: classes.closeButton, onClick: props.onClose, size: "large", id: ix(props.id, 'icon-button') },
            React.createElement(CloseIcon, null))),
        props.children));
}
//# sourceMappingURL=Dialog.js.map